import {
  DataService,
  ModalService,
  NotificationService,
  addNavMenuItem,
  registerBulkAction,
} from "@bb-vendure/admin-ui/core";
import { forkJoin, take } from "rxjs";
import { RemoveAlertDocument } from "src/generated-gql/graphql";

export default [
  addNavMenuItem(
    {
      id: "alerts",
      label: "nav.alert",
      routerLink: ["/extensions/alerts"],
      icon: "info",
    },
    "marketing"
  ),

  registerBulkAction({
    location: "alert-list",
    label: "Delete",
    icon: "remove",
    iconClass: "is-danger",
    onClick: ({injector,selection,hostComponent, clearSelection}) => {
      const modal = injector.get(ModalService);
      const dataService = injector.get(DataService)
      const noti = injector.get(NotificationService);

      modal.dialog({
        title: "Delete Alerts",
        body: `Are you sure you want to delete ${selection.length} alerts?`,
        buttons: [
          { label: "Cancel", type: "secondary", returnValue: false },
          { label: "Delete", type: "danger", returnValue: true },
        ],
      }).pipe(take(1))
      .subscribe((result) => {
        if (result) {
          const deleteObservables = selection.map((item) =>
            dataService.mutate(RemoveAlertDocument, { id: item.id })
          );

          forkJoin(deleteObservables).subscribe(res => {
            noti.success(`Deleted ${res.length} alerts`);
            hostComponent.refresh();
            clearSelection();
          });
          
        }
      });
    },
  }),
];
